import { useContext, useEffect, useState } from 'react'

import { Box, Button, Input, Modal, Text } from '@fairfashion/design-system'
import { useForm } from 'react-hook-form'

import { FeedbackAlertContext } from '../../../../components/FeedbackAlert'
import { QRCodeDetailsContext } from '../../qrcode-details.context'

import {
  QRCodeDetailsPartForm,
  QRCodeDetailsPartFormModalProps,
} from './qrcode-details-part-form-modal.types'

export const QRCodeDetailsPartFormModal = ({
  defaultValues,
  index,
  open,
  onClose,
}: QRCodeDetailsPartFormModalProps) => {
  const [saving, setSaving] = useState(false)

  const { feedbackAlert } = useContext(FeedbackAlertContext)
  const { qrcode, actions } = useContext(QRCodeDetailsContext)

  const { register, reset, handleSubmit } = useForm<QRCodeDetailsPartForm>()

  const currentIndex = qrcode?.finishedItemProfile?.parts?.length || 0

  useEffect(() => {
    if (open) {
      if (defaultValues && index !== undefined) {
        reset({
          index: `#${index + 1}`,
          code: defaultValues.code,
          name: defaultValues.name,
        })
        return
      }

      reset({
        index: `#${currentIndex + 1}`,
        code: '',
        name: '',
      })
    }
  }, [open])

  const onSubmit = async (data: QRCodeDetailsPartForm) => {
    setSaving(true)

    await actions.saveFinishedItemProfilePart(data)

    setSaving(false)
    onClose()
    feedbackAlert('Salvo com sucesso', 'success')
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Parte"
      width="800px"
      maxWidth="90%"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box width="100%" direction="column" gap={3}>
          <Box width="100%" direction="column" gap={2}>
            <Box gap={2} width="100%">
              <Box width="70px">
                <Input label="Parte" {...register('index')} disabled />
              </Box>
              <Box flex={1}>
                <Input
                  label="Código"
                  {...register('code')}
                  disabled={!!defaultValues}
                  required
                />
              </Box>
            </Box>
            <Box width="100%">
              <Input label="Nome" {...register('name')} required />
            </Box>
          </Box>

          <Box width="100%" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={onClose} padding="10px 16px">
              <Text size="small" fontWeight={500}>
                Cancelar
              </Text>
            </Button>
            <Button padding="10px 16px" type="submit" loading={saving}>
              <Text size="small" fontWeight={500} color="white">
                Salvar
              </Text>
            </Button>
          </Box>
        </Box>
      </form>
    </Modal>
  )
}
